import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Table from 'components/Table'; // your custom table component

const ReminderDetails = () => {
  const location = useLocation();
  const reminder:any = location.state; // the rowData passed

  if (!reminder) return <div>No data found</div>;

  const columns = [
    { key: 'displayName', title: 'Client Name' }, // adjust key based on your client object
    { key: 'email', title: 'Email' },
    { 
      key: 'isMailSent', 
      title: 'Mail Sent', 
      render: (row) => (row.isMailSent ? 'SENT' : 'ERROR') 
    },
  ];

  return (
    <Box px={1}>
      <Table
        sx={{ mt: 3 }}
        data={reminder.clientDetails || []} // pass clientDetails as table data
        columns={columns}
        // pagination can be added if needed
      />
    </Box>
  );
};

export default ReminderDetails;
